import { createFileRoute } from '@tanstack/react-router';
import {
  cachedApprovedOrganization,
  organizationEventsQuery,
  pastEventsQuery,
  upcomingEventsQuery,
} from '@/features/organizer/api';
import { EventsPage } from '@/features/organizer/pages/EventsPage';
import {
  organizerEventsSearchSchema,
  toOrganizationEventsQuery,
} from '@/features/organizer/search';
import { belgradeToday } from '@/lib/format/format';

export const Route = createFileRoute('/_authed/org/$organizationId/events/')({
  staticData: { help: 'events' },
  validateSearch: organizerEventsSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, params, deps }) => {
    const organization = cachedApprovedOrganization(queryClient, params.organizationId);
    if (!organization) return;
    const today = belgradeToday();
    void queryClient.prefetchQuery(
      organizationEventsQuery(organization, toOrganizationEventsQuery(deps, today)),
    );
    void queryClient.prefetchQuery(upcomingEventsQuery(organization, today));
    void queryClient.prefetchQuery(pastEventsQuery(organization, today));
  },
  component: EventsPage,
});
